import { render } from "./PasswordForgot.vue?vue&type=template&id=666af52e&scoped=true"
import script from "./PasswordForgot.vue?vue&type=script&lang=js"
export * from "./PasswordForgot.vue?vue&type=script&lang=js"

import "./PasswordForgot.vue?vue&type=style&index=0&id=666af52e&lang=scss&scoped=true"

import exportComponent from "/var/www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-666af52e"]])

export default __exports__